import * as S from './styles';
import { colors } from '@/constants';
import { LinkPropsModal } from '@/types';
import { useCart, useClient, useGlobals, useClientHierarchy, useCorporateFlags } from '@/hooks';
import * as R from '@/constants/systemRoutes';
import { useLocation, useParams } from 'react-router-dom';
import { ModalListCompanies, CartCounter, SelectedClient } from '@/components';

import { RiLogoutBoxRLine, RiUser3Line } from 'react-icons/ri';

export type Types = {
  [key in LinkPropsModal]?: any;
};

const Menu = () => {
  const { pathname } = useLocation();
  const { totalQuantity } = useCart();
  const { selectedClient } = useClient();
  const { activeTheme } = useGlobals();
  const { brandTheme } = useCorporateFlags()
  const { selectedRCA, isCoordinatorActive, handleLogoutRCA: logoutRCA } = useClientHierarchy();

  const params = Object.entries(useParams());

  const partialMenu = [R.DASHBOARD, !isCoordinatorActive ? { ...R.CHOICE_CLIENT, modal: null, link: '/meus-clientes' } : { ...R.CHOICE_RCA, modal: null, link: '/meus-rcas' }];

  const fullyMenu = [R.ECOMMERCE, R.CATEGORIES, R.CART, R.MY_ACCOUNT, R.COMBOS];
  const listToHide = [
    R.MAIN,
    R.LOGIN,
    R.COMPANY,
    R.CHECKOUT,
    R.USER_DATA,
    R.MY_CLIENTS,
    R.SALES_CYCLE,
    R.ORDER_STATUS_PAGE,
    R.PRODUCTIVITY_EXTRACT,
    R.INDICATORS,
    R.PERFORMANCE_INDICATORS,
    R.SALES_REPORT,
    R.NEW_CLIENT,
    R.MODULES,
    R.TITLE_REPORT,
    R.MESSAGES,
    R.MESSAGE,
    R.COMISSION_REPORT,
    R.RETURN_REPORT,
    R.ORDER_REPORT,
    R.COORDINATOR_VIEW
  ];

  const isDashBoard = pathname.includes('dashboard');
  const isClientView = (selectedClient?.COD_CLIENTE && !isDashBoard) || !isDashBoard;

  const menu = isClientView ? fullyMenu : partialMenu;

  const path = params.reduce((acc, [k, v]) => `${acc?.replace(`/${v}`, `/:${k}`)}`, pathname);

  const Link = (item: any, ind: number) => {
    const matchs = [...(item?.match || []), item.link];
    const isActive = matchs.includes(path);
    if (!item.modal) {
      const activeColor = brandTheme?.active_color || colors.brand.yellow;
      const inactiveColor = brandTheme?.text_color || colors.brand.white;
      const color = isActive ? activeColor : inactiveColor;
      return (
        <S.NavLink
          key={`item-menu-${ind}`}
          to={item.link}
          data-test={`menu-component-link-${item.id}`}
          color={color}
        >
          {item.link === '/carrinho' && totalQuantity > 0 && <CartCounter cartTotalQuantity={totalQuantity} />}
          {isActive && <S.SelectedBar $color={color} />}
          <S.Icon>{item.icon}</S.Icon>
          {item.title}
        </S.NavLink>
      );
    }

    const listModals: Types = {
      // 'modal-sync': ModalSync,
      'modal-companies': ModalListCompanies,
    };

    const Modal = listModals[item.modal as LinkPropsModal];

    return (
      <Modal key={`item-menu-${ind}`}>
        <S.ItemLink color={colors.brand.white}>
          <S.Icon>{item.icon}</S.Icon>
          {item.title}
        </S.ItemLink>
      </Modal>
    );
  };

  const shouldHide = listToHide.find(({ link }) => path === link || pathname === link);
  if (shouldHide) return null;

  return (
    <>
      {selectedRCA && isDashBoard && (
        <S.LoggedRCAContainer className="scroll-down">
          <RiUser3Line size={24} />
          <S.LoggedRCA>
            <small>Você está logado como</small>
            <strong>{selectedRCA?.firstname} {selectedRCA?.lastname || ''}</strong>
          </S.LoggedRCA>
          <S.LogoutRCA onClick={logoutRCA} data-test="menu-logout-rca-button">
            <RiLogoutBoxRLine size={24} />
          </S.LogoutRCA>
        </S.LoggedRCAContainer>
      )}

      <S.MenuContainer className="scroll-down" $color={brandTheme?.bg_active_color}>
        <SelectedClient />
        {activeTheme?.menuFlutuante && <S.MenuBoxDecoration src={activeTheme?.menuFlutuante} />}
        {activeTheme?.badgeBottom && <S.MenuRightDecoration src={activeTheme?.badgeBottom} />}
        <S.Content>{menu.map(Link)}</S.Content>
      </S.MenuContainer>
    </>
  );
};

export default Menu;
